import { Component, OnInit } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { Order } from 'src/app/interfaces/order.interface';
import { Total } from 'src/app/interfaces/total.interface';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { TransferService } from 'src/app/services/transfer.service';
import { Totalssum } from 'src/app/interfaces/totalssum';
import { ReceiveOrder } from 'src/app/interfaces/receive-order';
import { AngularFirestore } from '@angular/fire/firestore';
import { when } from 'jquery';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  order: ReceiveOrder[] = []

  total: Total[] = []

  length: number = null;

  subtotal: number = null;

  sumtotals: Totalssum[] =[]

  title_ar:boolean = true
  
  title_en:boolean = false
  
  tax:number = null

  all:number = null

  constructor(private Order:CartService, private fs: AngularFirestore, private translate: TranslateService) {
   
    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.title_ar = false
        this.title_en = true
      }
      else if(this.translate.currentLang == "ar") {
        this.title_ar = true
        this.title_en = false
      }
    })
   
  }

  sum:boolean=false;

  ngOnInit(): void {
    this.Order.getOrder().subscribe(data => { 
      this.order = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
      this.length = data.length;
   })
    setTimeout(()=>{
      this.sum = true;
      }, 1000);
      setTimeout(()=>{
        this.sum = false;
      }, this.length*1000);
      setTimeout(()=>{
        this.susm()
      },4000)   
  }
 
  lx:Array<number> = []
 
  totalll:number = null

  gocheck:boolean = true;

    recieve(x:number) {
          
          this.lx.push(x);
    }

    susm() { 
          this.lx.length = this.length;

          let v = this.lx.reduce( (accumulator, currentValue) => accumulator + currentValue )

          this.totalll = v;

         console.log(this.totalll, ':التكلفة الكاملة')

         this.gocheck = true;

         document.getElementById('ff').style.display="block";

         this.tax = this.totalll * 0.15

         console.log(this.tax, ':الضريبة المضافة')

         this.all = this.tax + this.totalll    
    }

    resum() {
     this.lx = []

     this.totalll = null
     
     this.tax = null
     
     this.all = null
     
     console.log("total", this.totalll, "tax", this.tax, "all", this.all)
     
     setTimeout(()=>{
      this.sum = true;
      }, 1000);
      setTimeout(()=>{
         this.sum = false;
      }, this.length*1000);
      setTimeout(()=>{
        this.susm()
      },4000)
    }

  update(index) {
    this.resum()
    // this.gocheck = false;
    // document.getElementById('ff').style.display="none";
    // document.getElementById('recal').style.display="block";
    this.Order.update(this.order[index].id,this.order[index].amount)
    .then(()=> {
      document.getElementById('updated').style.display="block";
      setTimeout(()=>{
        document.getElementById('updated').style.display="none";
      }, 5000);
    })
  }

  delete(index) {
    this.gocheck = false;
    document.getElementById('ff').style.display="none";
    document.getElementById('recal').style.display="block";
    this.Order.delete(this.order[index].id)
    .then(()=>{
      document.getElementById('removed').style.display="block";
      setTimeout(()=>{
        document.getElementById('removed').style.display="none";
      }, 5000);
    })
  }


}
